import React, { useState } from 'react';
import { Alert, Space } from '@bedrock/components';
import Icon, { ChevronRight } from '@bedrock/icons-react';
import { useMemoizedFn } from 'ahooks';
import classNames from 'classnames/bind';
import styles from './index.less';
import StarChartMonitoringLinkModal from '../StarChartMonitoringLinkModal';
import { ReactComponent as StarChartLogo } from '@mpc/common/src/images/StarChartLogo.svg';

const cx = classNames.bind(styles);

export interface MonitoringLinkAlertProps {
  detail?: any;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * 监测链接 Alert 入口组件
 * 制作中场景下显示在表单顶部
 */
export default function MonitoringLinkAlert(props: MonitoringLinkAlertProps) {
  const { detail, className, style } = props;
  const [visible, setVisible] = useState(false);

  const handleClick = useMemoizedFn(() => {
    setVisible(true);
  });

  const handleClose = useMemoizedFn(() => {
    setVisible(false);
  });

  return (
    <>
      <div
        className={cx('monitoring-link-alert-wrapper', className)}
        style={style}
        onClick={handleClick}
      >
        <Alert
          className={cx('monitoring-link-alert')}
          type="info"
          showIcon={true}
          icon={<Icon component={StarChartLogo} className={cx('star-chart-icon')} size={16}/>}
          message={(
            <Space className={cx('alert-content')} size={0}>
              <span className={cx('alert-text')}>查看星图监测链接</span>
              <ChevronRight className={cx('arrow-icon')} />
            </Space>
          )}
        />
      </div>
      <StarChartMonitoringLinkModal
        visible={visible}
        onClose={handleClose}
        detail={detail}
      />
    </>
  );
}
